import { Box, Radio, Text, useColorModeValue } from "@chakra-ui/react";
import PropTypes from "prop-types";
import { forwardRef } from "react";

const RadioBox = forwardRef(
  /**
   * To be used inside a Chakra/Raiden radio-group
   * @param {{
   * value: any,
   * text: React.ReactNode | string,
   * description?: React.ReactNode,
   * isDisabled?: boolean,
   * } & import("@chakra-ui/react").BoxProps} props
   */
  function RadioBox(
    { value, text, description, isDisabled, ...otherProps },
    ref,
  ) {
    const color = useColorModeValue("#000", "#fff");
    const colorDescription = useColorModeValue("gray.700", "gray.300");

    return (
      <Box
        as="label"
        display="block"
        borderWidth="1px"
        p=".75rem"
        cursor={isDisabled ? "initial" : "pointer"}
        {...otherProps}>
        <Radio
          ref={ref}
          value={value}
          mb={description ? ".5rem" : undefined}
          isDisabled={isDisabled ?? false}
          colorScheme="brandPrimary">
          {typeof text === "string" ? <Text color={color}>{text}</Text> : text}
        </Radio>

        {description && (
          <Text
            fontSize="0.875rem"
            color={colorDescription}
            opacity={isDisabled ? 0.4 : 1}>
            {description}
          </Text>
        )}
      </Box>
    );
  },
);

RadioBox.propTypes = {
  value: PropTypes.any,
  text: PropTypes.node,
  description: PropTypes.node,
  isDisabled: PropTypes.bool,
  children: PropTypes.node,
};

RadioBox.defaultProps = {};

export default RadioBox;
